import { offerVersionEndpoints } from '@ooh/contracts';
import { apiQueryKey } from '../../../data/use-api-suspense-query';

export const offerVersionsRequest = (offerId: string) => ({ id: Number(offerId) });

export const unitDecisionsRequest = (offerId: string, versionId: number) => ({
  offerId: Number(offerId),
  versionId,
});

export const offerVersionsQueryKey = (offerId: string) =>
  apiQueryKey(offerVersionEndpoints.list, offerVersionsRequest(offerId));

export const allOfferVersionsQueryKey = () => apiQueryKey(offerVersionEndpoints.list);

export const unitDecisionsQueryKey = (offerId: string, versionId: number) =>
  apiQueryKey(offerVersionEndpoints.unitDecisions, unitDecisionsRequest(offerId, versionId));
